export function pastedSignupInviteUrl(value) {
  const candidate = value?.trim();
  if (!candidate) return null;

  try {
    const url = new URL(candidate);
    if (url.protocol !== 'https:' || !url.host) return null;

    return candidate;
  } catch {
    return null;
  }
}

export function signupInviteCode(value) {
  const candidate = value?.trim();
  if (!candidate || !/^[A-Za-z0-9]{6}$/.test(candidate)) return null;

  return candidate.toUpperCase();
}

export function classifySignupInvite(value) {
  const inviteUrl = pastedSignupInviteUrl(value);
  if (inviteUrl) return { kind: 'url', value: inviteUrl };

  const code = signupInviteCode(value);
  if (code) return { kind: 'code', value: code };

  return null;
}
